import React from "react"
import { Link } from 'gatsby'
import { GatsbyImage } from "gatsby-plugin-image";

function Brick({slug, thumbnail, caption, url, hideCaption, styles})
{
    let hide = (hideCaption) ? "hide" : "";
    let link = (url) ? url : slug;
    let isStatement = !url && !thumbnail;
    let isExternalLink = !isStatement && url;
    let isInternalLink = !isStatement && !url;


    return (
        <div className={`brick ${styles}`} key={slug}>
            {isStatement && 
                <div className={`statement`}>{caption}</div>
            }
            {isExternalLink &&
            <a href={link}>
                {thumbnail.childImageSharp && <GatsbyImage
                    image={thumbnail.childImageSharp.gatsbyImageData}
                    imgStyle={{transition: "transform .3s ease"}}
                    object-fit="contain"
                    alt={caption} />}
                {thumbnail.childImageSharp === undefined && <img src={thumbnail} alt={caption}  />}
                <div className={`caption ${hide}`}>{caption}</div>
            </a>
            }
            {isInternalLink &&
            <Link to={link}>
                {thumbnail.childImageSharp && <GatsbyImage
                    image={thumbnail.childImageSharp.gatsbyImageData}
                    imgStyle={{transition: "transform .3s ease"}}
                    object-fit="contain"
                    alt={caption} />}
                {thumbnail.childImageSharp === undefined && <img src={thumbnail} alt={caption}  />}
                <div className={`caption ${hide}`}>{caption}</div>
            </Link>
            }
          </div>
    );
}

export default Brick